import React from "react";
import { Container } from "@mui/material";
import PanelWorkOrderList from "../components/WorkOrders/Panels/PanelWorkOrderList";

export default function Panels(props) {
    const { user, token, handleOpenSnackbar, darkState } = props;

    return (
        <Container
            maxWidth={false}
            sx={{
                pt: 0,
                pb: { xs: 2, sm: 3, md: 4 },
                px: 0,
            }}
        >
            <PanelWorkOrderList
                user={user}
                token={token}
                handleOpenSnackbar={handleOpenSnackbar}
                darkState={darkState}
            />
        </Container>
    );
}
